// extracted by mini-css-extract-plugin
export default {"nodeText":"nodeText-index-oxw13"};